import React, { Suspense } from "react";
import { Spin } from "antd";
const GamificationContainer = React.lazy(
  () => import("../../../modules/Gamification/components/index")
);

const GamificationPage = () => (
  <Suspense fallback={<Spin />}>
    <GamificationContainer />
  </Suspense>
);

export default GamificationPage;
